/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import ImageIcon from '@mui/icons-material/Image';

const EntitySummary = ({
  entityData,
  summaryFields,
  // Image upload props
  supportsImageUpload = false,
  selectedImage = null,
  onImageSelect,
  chatT,
  disabled = false
}) => {
  const hiddenFileInput = useRef(null);

  const handleImageButtonClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current?.click();
  };

  const handleImageChange = (event) => {
    if (!event.target.files || !event.target.files[0]) {
      return;
    }
    const file = event.target.files[0];
    onImageSelect?.(file);
  };

  return (
    <div className="ai-chat-entity-summary">
      {summaryFields.map(({ key, dataKey, label, formatter, icon: Icon, iconColor, fieldClassName, valueClassName }) => {
        const value = entityData[dataKey];
        // Allow 0 values (e.g., free tickets with price: 0) but filter null/undefined/empty strings
        if (value === null || value === undefined || value === '') return null;

        const displayValue = formatter ? formatter(value) : value;

        return (
          <div key={key} className={`summary-field ${fieldClassName || ''}`}>
            {label && <span className="summary-label">{label}</span>}
            {Icon && (
              <Icon
                fontSize="small"
                style={{ color: iconColor || 'var(--secondaryTextColor)' }}
              />
            )}
            <span className={`summary-value ${valueClassName || ''}`}>
              {displayValue}
            </span>
          </div>
        );
      })}

      {supportsImageUpload && (
        <>
          {selectedImage ? (
            <div className="summary-field summary-field-image">
              <span className="summary-label">{chatT('aiChat:labels:image')}:</span>
              <button
                type="button"
                className="summary-image-filename"
                onClick={handleImageButtonClick}
                disabled={disabled}
              >
                {selectedImage.name}
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="summary-image-upload"
              onClick={handleImageButtonClick}
              disabled={disabled}
            >
              <span className="summary-image-upload-left">
                <ImageIcon className="summary-image-upload-icon" />
                <span className="summary-image-upload-label">{chatT('aiChat:labels:image')}</span>
              </span>
              <span className="summary-image-upload-button-text">
                {chatT('aiChat:buttons:upload')}
              </span>
            </button>
          )}
          <input
            ref={hiddenFileInput}
            type="file"
            accept="image/jpeg, image/png, image/gif, image/bmp, image/webp"
            name="image"
            hidden
            onChange={handleImageChange}
          />
        </>
      )}
    </div>
  );
};

export default EntitySummary;

